const initialState = {
  tasks: [],
  jobs: [],
  isLoading: false,
};

function globalSearch(state = initialState, action) {
  switch (action.type) {
    case 'RESET_SEARCH_RESULTS':
      return {
        ...state,
        tasks: [],
        jobs: [],
      };
    case 'REQUEST_SEARCH':
      return {
        ...state,
        isLoading: true,
      };
    case 'RECEIVE_SEARCH_RESULTS':
      return {
        ...state,
        isLoading: false,
        tasks: action.tasks,
        jobs: action.jobs,
      };
    default:
      return state;
  }
}

export default globalSearch;
